import { queryOrThrow } from "@rootreeweb/js-lib";

/** Initializes all page selects. */
export default function init(): void {
	const elements = document.querySelectorAll<HTMLDivElement>(".rt-page-select");
	elements.forEach(initSearch);
}

/**
 * Initializes the search functionality for a page select.
 *
 * @param element The page select container.
 */
function initSearch(element: HTMLDivElement) {
	const select = queryOrThrow<HTMLSelectElement>(
		element,
		".rt-page-select-radio-group",
	);
	const search = queryOrThrow<HTMLInputElement>(
		element,
		".rt-page-select-search",
	);
	const options = select.querySelectorAll<HTMLElement>("label");
	search.addEventListener("input", () => {
		const searchTerm = search.value.toLowerCase();
		options.forEach((option) => handleOption(option, searchTerm));
	});
}

/**
 * Handles the display of an option based on the search term.
 *
 * @param option The option to handle.
 * @param searchTerm The search term.
 */
function handleOption(option: HTMLElement, searchTerm: string) {
	const optionValue = option.dataset.value?.toLowerCase() || "";
	if (!searchTerm || optionValue === "") {
		option.style.display = "block";
		return;
	}
	option.style.display = optionValue.includes(searchTerm) ? "block" : "none";
}
